export const getLocale = ({ i18nState: { lang } }) => lang;



// WEBPACK FOOTER //
// ./src/actions/language/selectors.js